import builder from '../builder';
import LightBulbShineAlternate from '../../streamline-icons/bold/light-bulb-shine-alternate.svg';

export default builder('IconListBullets1Bold', LightBulbShineAlternate);
